import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Step } from "@app/core/on-boarding/domain/model/step";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { StepMapper } from "@app/core/on-boarding/data/network/step.mapper";

@Injectable({
  providedIn: "root",
})
export class StepWS {
  constructor(private handler: BaseHandler) {}

  execute(): Observable<Step[]> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.ONBOARDING_ENDPOINT())
      .setMethod(HttpMethod.get)
      .build();

    return this.handler
      .execute(parameters)
      .pipe(map((response) => response.map(StepMapper.deserialize)));
  }
}
